import { Stack } from "@mui/material";
import { CbhIcon, Text, Title } from "@src/appV2/redesign/system/ui-components";
import { isRebrandingEnabled } from "@src/appV2/redesign/system/ui-theme";

interface OvertimeDisplayProps {
  hasExceededOvertimeThreshold: boolean;
  progress: number;
  overtimeText: string;
  totalTimeWorked: string;
}

export function OvertimeDisplay({
  hasExceededOvertimeThreshold,
  progress,
  overtimeText,
  totalTimeWorked,
}: OvertimeDisplayProps) {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      gap={isRebrandingEnabled() || hasExceededOvertimeThreshold ? 1 : 4}
      sx={{ width: "100%", ...(isRebrandingEnabled() && { marginTop: -6 }) }}
    >
      <Title
        component="h2"
        variant="h2"
        sx={{
          textAlign: "center",
          ...(isRebrandingEnabled() && {
            // Force body-font here because the serif font looks terrible with tabular-nums
            // It's important to have tabular-nums since this is ticking up and there's movement otherwise
            fontFamily: "Lato, sans-serif",
            fontVariantNumeric: "tabular-nums",
            fontWeight: 600,
          }),
        }}
      >
        {overtimeText}
      </Title>
      {progress >= 1 ? (
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          gap={1}
          sx={{ width: "100%" }}
        >
          <Stack alignItems="center" gap={1}>
            <Text sx={{ textAlign: "center" }}>
              <Text variant="body2">You may be auto</Text>
              <Text variant="body2">clocked out</Text>
            </Text>
            <CbhIcon type="info" />
          </Stack>
        </Stack>
      ) : (
        <Text variant="body1" sx={{ textAlign: "center" }}>
          {totalTimeWorked}
        </Text>
      )}
    </Stack>
  );
}
